import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SubPageHeading from '../../../organisms/SubPageHeading';
import {
  subPageHeading,
  subPageNavAZ,
  subPageNavNV,
  subPageNavCivilMatterAZ,
  subPageNavCivilMatterNV,
  subPageNavNM,
  subPageNavCivilMatterNM,
} from './ViewCase.constants';
import { CIVIL_MATTER_CASE } from '../../../../global/Case.constants';
// import EstimatedFeesBlock from '../../../molecules/EstimatedFeesBlock/EstimatedFeesBlock';
import { apiClient } from '../../../../lib/apiClient';
import { useBaseUrl } from '../../../../hooks/useBaseUrl';

const ViewCase = () => {
  const {
    state: { id, navPage, subNav, defendantName = '', refNum = '', stateCode, caseType },
  } = useLocation();
  const base = useBaseUrl();
  // const [estimatedFeesAmount, setEstimatedFeesAmount] = useState(null);
  const [setEstimatedFeesAmount] = useState(null);

  const subPageNavExtended = useMemo(() => {
    const isArizona = stateCode === 'AZ';
    const isNevada = stateCode === 'NV';
    const isNewMexico = stateCode === 'NM';
    const isCivilMatter = caseType === CIVIL_MATTER_CASE;

    let subNavigation = null;

    if (isArizona) {
      subNavigation = isCivilMatter ? subPageNavCivilMatterAZ(base) : subPageNavAZ(base);
    }
    if (isNevada) {
      subNavigation = isCivilMatter ? subPageNavCivilMatterNV(base) : subPageNavNV(base);
    }
    if (isNewMexico) {
      subNavigation = isCivilMatter ? subPageNavCivilMatterNM(base) : subPageNavNM(base);
    }

    return subNavigation?.map((item) => ({
      ...item,
      state: {
        stateCode,
        navPage,
        subNav,
        id,
        defendantName,
        refNum,
        caseType: caseType || null,
      },
    }));
  }, [stateCode, id, defendantName]);

  useEffect(() => {
    const fetcher = async () => {
      const apiByStateCode = {
        AZ: 'arizonaCase',
        NV: 'nevadaCases',
        NM: 'newMexicoCases',
      };
      const {
        data: { result },
      } = await apiClient.get(`/cp/api/${apiByStateCode[stateCode]}/${id}/fees`);
      setEstimatedFeesAmount(result?.estimatedAmount ?? null);
    };
    fetcher();
  }, [id, stateCode]);

  return (
    <>
      <SubPageHeading
        subPageHeading={
          defendantName && refNum ? `Ref. # ${refNum} | ${defendantName}` : subPageHeading
        }
        // temporary hidden functionality according to CLAR-1065
        // subPageHeadingRight={<EstimatedFeesBlock estimatedAmount={estimatedFeesAmount} />}
        subPageNav={subPageNavExtended}
        nav={{
          to: `/${base}/cases/casesearch`,
          state: {
            navPage: 'Cases',
          },
        }}
      />
      <Outlet />
    </>
  );
};

export default ViewCase;
